// TD-148: marks a subtree as carrying personal data so the two session
// recorders do not capture its values.
//
// Why this lives in code rather than in the vendors' dashboards: dashboard
// settings are invisible from the repo, are not reviewed, and silently stop
// applying if an account is reconfigured or replaced. Marking the DOM keeps the
// rule next to the fields it protects, and both vendors treat an element-level
// rule as overriding their site-wide setting.
//
// What each vendor does by default, checked against their docs on 2026-08-20:
//   - Clarity masks input box content in ALL masking modes and says it "can't
//     be customized", so inputs were never the exposure. Its default Balanced
//     mode only treats numbers and email addresses as sensitive, so ordinary
//     rendered TEXT — a child's name on a confirmation screen — is captured
//     unless marked.
//   - FullStory is the real gap: unless the org has Private by Default or Form
//     Privacy switched on, "unmask is the default state for data capture", so
//     input values are recorded. We cannot see org 11VXS6's dashboard from
//     here, so we do not rely on it being configured.
//
// MASK, not EXCLUDE, is deliberate. FullStory's mask rule drops the text values
// but still records clicks and change events; exclude drops the interactions
// too. TD-148 and TD-129 both need those interactions — they are how a form
// drop-off is located. Masking gives us the behaviour without the content.
//
// Both attributes cascade to descendants, so apply this to the container that
// wraps the fields rather than to each input. New fields added inside are then
// covered automatically.

export const SESSION_PRIVATE_CLASS = "fs-mask";

/**
 * Spread onto the element wrapping any personal data.
 *
 *   <div {...sessionPrivate()}>            — no existing class
 *   <div {...sessionPrivate("details-col")} — merges with one
 */
export const sessionPrivate = (className?: string) => ({
    className: className
        ? `${className} ${SESSION_PRIVATE_CLASS}`
        : SESSION_PRIVATE_CLASS,
    "data-clarity-mask": "True"
});
